import React from "react";
import SimpleInput from "../../../../modules/SimpleInput";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleDDL from "../../../../modules/SimpleDDL";
import Button from "../../../../modules/commons/Button";

export const tableConfigDetailPart = {
  withQR: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "kodePart",
      label: "Kode Part",
      options: {
        sort: false,
      },
    },
    {
      name: "partName",
      label: "Nama Part",
      options: {
        sort: false,
      },
    },
    {
      name: "category",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "qty",
      label: "Qty",
      options: {
        customBodyRender: (value) => {
          return !value ? 1 : value;
        },
        sort: false,
      },
    },
    {
      name: "satuan",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "partBarcode",
      label: "QR Code",
      options: {
        sort: false,
      },
    },
  ],
  withoutQR: (changeValue, deleteRow) => [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "kodePart",
      label: "Kode Part",
      options: {
        sort: false,
      },
    },
    {
      name: "partName",
      label: "Nama Part",
      options: {
        sort: false,
      },
    },
    {
      name: "category",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "qty",
      label: "Qty",
      options: {
        sort: false,
      },
    },
    {
      name: "satuan",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "actualQty",
      label: "Act Qty",
      options: {
        sort: false,
        customBodyRender: (val, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val == "" ? 0 : val;
          }
          return (
            <SimpleInput
              id="input_act_qty"
              name="actualQty"
              box="number"
              value={val}
              onValueChange={({ value }) => {
                changeValue(rowIndex, "actualQty", value);
                changeValue(
                  rowIndex,
                  "diffQty",
                  Number(value) - (rowData[4] || 0),
                );
              }}
            />
          );
        },
      },
    },
    {
      name: "diffQty",
      label: "Diff Qty",
      options: {
        sort: false,
        customBodyRender: (val, { rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val;
          }
          return (
            <SimpleInput
              id="input_act_qty"
              name="diffQty"
              box="number"
              readOnly
              value={val}
              onChange={() => {}}
            />
          );
        },
      },
    },
    {
      name: "note",
      label: "Keterangan",
      options: {
        sort: false,
        customBodyRender: (val, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val;
          }
          return (
            <SimpleInput
              id="input_act_qty"
              name="note"
              value={val}
              onChange={({ target }) =>
                changeValue(rowIndex, "note", target.value)
              }
            />
          );
        },
      },
    },
    {
      name: "isSaved",
      label: "Aksi",
      options: {
        sort: false,
        customBodyRender: (val, { rowIndex }) => {
          return (
            <FlexView style={{ gap: "15px" }}>
              {val ? (
                <Button
                  className="btnAct"
                  onClick={(e) => {
                    e.preventDefault();
                    changeValue(rowIndex, "isSaved", false);
                  }}
                >
                  <i
                    className="fa fa-pencil-alt"
                    style={{
                      fontSize: 20,
                      color: "red",
                    }}
                  />
                </Button>
              ) : (
                <Button
                  className="btnAct"
                  onClick={(e) => {
                    e.preventDefault();
                    changeValue(rowIndex, "isSaved", true);
                  }}
                >
                  <i
                    className="fa fa-save"
                    style={{
                      fontSize: 20,
                      color: "red",
                    }}
                  />
                </Button>
              )}
              <Button
                className="btnAct"
                onClick={(e) => {
                  e.preventDefault();
                  deleteRow(rowIndex, "dataTable");
                }}
              >
                <i
                  className="fa fa-times-circle"
                  style={{
                    fontSize: 20,
                    color: "red",
                  }}
                />
              </Button>
            </FlexView>
          );
        },
      },
    },
  ],
};

export const tableConfigPartReportSO = {
  withQR: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "partCode.kodePart",
      label: "Kode Part",
      options: {
        sort: false,
      },
    },
    {
      name: "partCode.partName",
      label: "Nama Part",
      options: {
        sort: false,
      },
    },
    {
      name: "partCode.partCategory.value",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "qty",
      label: "Qty",
      options: {
        customBodyRender: (value) => {
          return !value ? 1 : value;
        },
        sort: false,
      },
    },
    {
      name: "partCode.satuan.value",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "partBarcode",
      label: "QR Code",
      options: {
        sort: false,
      },
    },
    {
      name: "partExist",
      label: "Status",
      options: {
        sort: false,
        customBodyRender: (val) => {
          return val ? "DITEMUKAN" : "TIDAK DITEMUKAN";
        },
      },
    },
    {
      name: "userId.name",
      label: "User",
      options: {
        sort: false,
      },
    },
  ],
  withoutQR: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "partCode.kodePart",
      label: "Kode Part",
      options: {
        sort: false,
      },
    },
    {
      name: "partCode.partName",
      label: "Nama Part",
      options: {
        sort: false,
      },
    },
    {
      name: "partCode.partCategory.value",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "qty",
      label: "Qty",
      options: {
        sort: false,
        customBodyRender: (val) => {
          return val || 0;
        },
      },
    },
    {
      name: "partCode.satuan.value",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "actualQty",
      label: "Act Qty",
      options: {
        sort: false,
      },
    },
    {
      name: "diffQty",
      label: "Diff Qty",
      options: {
        sort: false,
      },
    },
    {
      name: "note",
      label: "Keterangan",
      options: {
        sort: false,
      },
    },
    {
      name: "userId",
      label: "User",
      options: {
        sort: false,
        customBodyRender: (value) => {
          if (!value) return "-";
          return value.name || "-";
        },
      },
    },
  ],
};

export const tableConfigPartKelebihan = (
  ddlPart = [],
  onChange,
  dataKelebihan,
  changeValue,
  deleteRow,
  dataKekurangan,
) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;
        return <>{rowNumber}</>;
      },
    },
  },
  {
    name: "item.kodePart",
    label: "Kode Part",
    options: { sort: false },
  },
  {
    name: "item.partName",
    label: "Nama Part",
    options: {
      sort: false,
      customBodyRender: (value, tableMeta) => {
        const rowIndex = tableMeta.rowIndex;
        const currentRow = dataKelebihan?.listDataTanpaQR?.[rowIndex];
        const isSaved = currentRow?.isSaved;
        const textError = dataKelebihan?.errorsTanpaQR?.[rowIndex]?.code;

        const selectedKelebihan =
          dataKelebihan?.listDataTanpaQR
            ?.filter((_, i) => i !== rowIndex) 
            ?.map((item) => item?.item?.kodePart) || [];

        const selectedKekurangan =
          dataKekurangan?.map((item) => item?.item?.kodePart) || [];

        const allSelected = [...selectedKelebihan, ...selectedKekurangan];
        const currentKode = currentRow?.item?.kodePart;

        const filteredOptions = ddlPart.filter((opt) => {
          if (opt.value === currentKode) return true;
          return !allSelected.includes(opt.value);
        });

        const val = currentKode
          ? {
              value: currentKode,
              label: currentRow?.item?.partName,
            }
          : null;

        if (isSaved) return val?.label || "-";

        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <SimpleDDL
              id={`ddl_part_${rowIndex}`}
              containerclassname="margin-bottom-none width width-200px"
              name="partName"
              options={filteredOptions}
              isClearable
              value={val}
              box="search"
              menuPosition="fixed"
              onChange={(opt) => onChange(rowIndex, "partName", opt)}
            />

            {textError && (
              <span
                style={{
                  color: "red",
                  fontSize: "12px",
                  marginTop: "4px",
                }}
              >
                {textError}
              </span>
            )}
          </div>
        );
      },
    },
  },
  {
    name: "item.partCategory.value",
    label: "Kategori",
    options: { sort: false },
  },
  {
    name: "systemQty",
    label: "Qty",
    options: {
      customBodyRender: (value) => {
        return !value ? 0 : value;
      },
      sort: false,
    },
  },
  {
    name: "item.satuan.value",
    label: "Satuan",
    options: { sort: false },
  },
  {
    name: "diffQty",
    label: "Diff Qty",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = dataKelebihan?.listDataTanpaQR?.[rowIndex]?.isSaved;
        const textError = dataKelebihan?.errorsTanpaQR?.[rowIndex]?.diffQty;
        if (isSaved) return val ?? "";

        const safeValue =
          typeof val === "string" ? val.replace("+", "") : (val ?? "");

        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <SimpleInput
              id="input_act_qty"
              name="diffQty"
              containerclassname="margin-bottom-none width width-80px"
              box="onlyNumber"
              value={val}
              onChange={(e) =>
                onChange(rowIndex, "diffQty", Number(e.target.value || 0))
              }
            />

            {textError && (
              <span
                style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
              >
                {textError}
              </span>
            )}
          </div>
        );
      },
    },
  },
  {
    name: "notes",
    label: "Keterangan",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = dataKelebihan?.listDataTanpaQR?.[rowIndex]?.isSaved;
        const textError = dataKelebihan?.errorsTanpaQR?.[rowIndex]?.notes;
        if (isSaved) {
          return val;
        }
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <SimpleInput
              id="input_act_qty"
              name="notes"
              containerclassname="margin-bottom-none width width-200px"
              value={val}
              onChange={({ target }) =>
                onChange(rowIndex, "notes", target.value)
              }
            />

            {textError && (
              <span
                style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
              >
                {textError}
              </span>
            )}
          </div>
        );
      },
    },
  },
  {
    name: "isSaved",
    label: "Aksi",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex }) => {
        return (
          <FlexView style={{ gap: "15px" }}>
            {val ? (
              <Button
                className="btnAct"
                onClick={(e) => {
                  e.preventDefault();
                  if (typeof changeValue === "function") {
                    changeValue(rowIndex, "isSaved", false);
                  }
                }}
              >
                <i
                  className="fa fa-pencil-alt"
                  style={{
                    fontSize: 20,
                    color: "red",
                  }}
                />
              </Button>
            ) : (
              <Button
                className="btnAct"
                onClick={(e) => {
                  e.preventDefault();
                  if (typeof changeValue === "function") {
                    changeValue(rowIndex, "isSaved", true);
                  }
                }}
              >
                <i
                  className="fa fa-save"
                  style={{
                    fontSize: 20,
                    color: "red",
                  }}
                />
              </Button>
            )}

            <Button
              className="btnAct"
              onClick={(e) => {
                e.preventDefault();
                if (typeof deleteRow === "function") {
                  deleteRow(rowIndex);
                }
              }}
            >
              <i
                className="fa fa-times-circle"
                style={{
                  fontSize: 20,
                  color: "red",
                }}
              />
            </Button>
          </FlexView>
        );
      },
    },
  },
];

export const tableConfigPartKekurangan = {
  withQR: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "partCode.kodePart",
      label: "Kode Part",
      options: {
        sort: false,
      },
    },
    {
      name: "partCode.partName",
      label: "Nama Part",
      options: {
        sort: false,
      },
    },
    {
      name: "partCode.partCategory.value",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "partCode.qty",
      label: "Qty",
      options: {
        customBodyRender: (value) => {
          return !value ? 1 : value;
        },
        sort: false,
      },
    },
    {
      name: "partCode.satuan.value",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "partBarcode",
      label: "QR Code",
      options: {
        sort: false,
      },
    },
  ],
  withoutQR: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "item.kodePart",
      label: "Kode Part",
      options: {
        sort: false,
      },
    },
    {
      name: "item.partName",
      label: "Nama Part",
      options: {
        sort: false,
      },
    },
    {
      name: "item.partCategory.value",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "systemQty",
      label: "Qty",
      options: {
        sort: false,
      },
    },
    {
      name: "item.satuan.value",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "differenceQty",
      label: "Diff Qty",
      options: {
        sort: false,
      },
    },
    {
      name: "note",
      label: "Keterangan",
      options: {
        sort: false,
      },
    },
  ],
};
